// removed by extract-text-webpack-plugin
module.exports = {"logo-wrapper":"main_nav-2jv","logo":"main_nav-3Rz"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Logo/logo.module.scss
// module id = 351
// module chunks = 0